export class LobbyEntryEdit {
    AccountNumber?: string;
    FirstName?: string;
    LastName?: string;
    DateOfBirth?: string;
    Notes?: string;
    Comments?: string;
    PhoneNumber?: string;
    EmailAddress?: string;
    PreferredLanguage?: number;
    RecieveTextMessage?: boolean;
    AddedBy?: number;
    ServiceRequested?: number[];
    CustomFieldValues: any;
    UserRequested?: number | null;
    GroupRequested?: number | null;
    StatusId?: number;
    LocationId?: number;
    addedLocalTime?: string;
}
